import * as React from "react";
function SvgWeb(props) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 15.449A7.317 7.317 0 108 .815a7.317 7.317 0 000 14.634z"
        stroke="#fff"
        strokeWidth={0.75}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 15.449c2.02 0 3.659-3.276 3.659-7.317S10.02.815 8 .815c-2.02 0-3.659 3.276-3.659 7.317 0 4.04 1.638 7.317 3.659 7.317zM8 .668v14.78M15.317 8.132H.683"
        stroke="#fff"
        strokeWidth={0.75}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgWeb;
